import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import showOnMouseMove from './showOnMouseMove.js'

export default contract({
  showOnMouseMove: array([
    showOnMouseMove
  ]),
})